export default {
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.guides": "Poradniki",
  "nav.faq": "FAQ",
  "nav.shopGuide": "Przewodnik zakupowy",

  "hero.badge": "Centrum zasobów USFans Spreadsheet",
  "hero.title": "USFans Spreadsheet — znajdź produkty, sprzedawców i zasoby szybciej",
  "hero.subtitle": "Poznaj zasoby USFans Spreadsheet, poradniki sprzedawców, badanie produktów, QC, koszty wysyłki, informacje o magazynie, recenzje, kupony i poradniki bezpieczeństwa — wszystko w jednym miejscu.",
  "hero.ctaPrimary": "Odkryj USFans Spreadsheet",
  "hero.ctaSecondary": "Przeglądaj poradniki USFans",
  "hero.note": "Przeglądaj kategorie poniżej i przejdź prosto do głównego sklepu.",

  "cat.title": "Przeglądaj kategorie produktów",
  "cat.subtitle": "Wybierz kategorię, aby otworzyć ją na głównej stronie. Użyj listy rozwijanej lub naciśnij przycisk poniżej.",
  "cat.dropdownLabel": "Wybierz kategorię",
  "cat.dropdownPlaceholder": "Wybierz kategorię…",
  "cat.open": "Otwórz na głównej stronie",

  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy/Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie/Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  "about.title": "Czym jest USFans Spreadsheet?",
  "about.p1": "USFans Spreadsheet to uporządkowany katalog, który grupuje buty, bluzy, koszulki, stroje sportowe, akcesoria i więcej w jedną, łatwą do przeglądania listę. Zamiast przeszukiwać cały sklep, możesz przejść prosto do wybranej sekcji.",
  "about.p2": "Został stworzony, by oszczędzać czas — porównuj produkty obok siebie, sprawdzaj notatki sprzedawców i rozumiej wysyłkę przed zakupem. Traktuj go jako skrót badawczy, który prowadzi do właściwych produktów na głównej stronie.",

  "features.title": "Popularne zasoby USFans",
  "features.subtitle": "Poradniki, które pomagają kupować mądrzej i bezpieczniej.",
  "features.review.title": "Recenzja USFans",
  "features.review.desc": "Co kupujący mówią o produktach, sprzedawcach i ogólnym doświadczeniu.",
  "features.shipping.title": "Koszt wysyłki",
  "features.shipping.desc": "Poznaj opcje wysyłki, informacje o magazynie i czasach dostawy.",
  "features.coupon.title": "Kupony i zniżki",
  "features.coupon.desc": "Wskazówki, jak znaleźć oszczędności, kupony i kody rabatowe.",
  "features.safety.title": "Bezpieczeństwo i legalność",
  "features.safety.desc": "Czy USFans jest legalny? Praktyczne wskazówki dotyczące bezpieczeństwa i weryfikacji.",

  "guides.title": "Najnowsze poradniki",
  "guides.subtitle": "Oryginalne, pogłębione artykuły wokół USFans Spreadsheet.",
  "guides.readMore": "Czytaj artykuł",

  "cta.title": "Gotowy na przegląd pełnego katalogu?",
  "cta.subtitle": "Otwórz główny sklep USFans, aby przeglądać wszystkie produkty, zobaczyć aktualne ceny i dokończyć zamówienie.",
  "cta.primary": "USFans Spreadsheet",
  "cta.secondary": "Kup Teraz",

  "faq.title": "Najczęściej zadawane pytania",
  "faq.q1": "Czym jest USFans Spreadsheet?",
  "faq.a1": "To uporządkowany katalog produktów, który grupuje streetwear i produkty dla fanów według kategorii, prowadząc do głównego sklepu w celu zakupu.",
  "faq.q2": "Czy przeglądanie jest darmowe?",
  "faq.a2": "Tak, przeglądanie kategorii jest proste. Ceny i finalizacja zakupu odbywają się na głównej stronie.",
  "faq.q3": "Jak kupić produkt?",
  "faq.a3": "Wybierz kategorię, otwórz ją na głównej stronie i dokończ tam zamówienie.",
  "faq.q4": "Czy USFans jest legalny?",
  "faq.a4": "Zawsze weryfikuj oficjalny sklep, metody płatności i regulamin przed zakupem oraz unikaj podobnie wyglądających stron.",

  "footer.tagline": "Niezależne źródło informacji o USFans Spreadsheet.",
  "footer.explore": "Przeglądaj",
  "footer.resources": "Zasoby",
  "footer.mainSite": "Główna strona",
  "footer.disclaimer": "Ta strona jest niezależnym źródłem informacji. Informacje mogą się zmieniać w czasie. Zawsze weryfikuj ważne informacje przed dokonaniem zakupu, płatności lub udostępnieniem danych osobowych.",
  "footer.rights": "Wszelkie prawa zastrzeżone.",
};